import { handleActions } from "redux-actions";

import { setPublishRequestStatuses } from "./actions";

const initialState = {
    isLoadingPublishRequestStatuses: false,
    codes: [],
    publishRequestStatuses: {}
};

export const publishRequestStatusesReducer = handleActions(
    {
        [setPublishRequestStatuses]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
